import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from "rxjs";
import {DjangoApiService} from "../../../../shared/services/django-api.service";
import {SnackbarService} from "../../../../shared/services/snackbar.service";
import {LanguageService} from "../../../../shared/services/language.service";
import {LangChangeEvent, TranslateModule, TranslateService} from "@ngx-translate/core";
import {AuthService} from "../../../../shared/services/auth.service";
import {ActivatedRoute, RouterLink, RouterOutlet} from "@angular/router";
import {MatDialog} from "@angular/material/dialog";
import {DialogConfirmComponent} from "../../../../shared/components/dialogs/dialog-confirm/dialog-confirm.component";
import {CardsBasicComponent} from "../../../../shared/components/cards/cards-basic/cards-basic.component";
import {LocalizeRouterPipe} from "@gilsdav/ngx-translate-router";
import {MatButton, MatIconButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {MatListItem, MatNavList} from "@angular/material/list";

@Component({
  selector: 'app-category-list-admin',
  standalone: true,
  imports: [
    MatButton,
    CardsBasicComponent,
    RouterOutlet,
    RouterLink,
    MatListItem,
    MatNavList,
    MatIcon,
    MatIconButton,
    LocalizeRouterPipe,
    TranslateModule
  ],
  templateUrl: './category-list-admin.component.html',
  styleUrl: './category-list-admin.component.css'
})
export class CategoryListAdminComponent implements OnInit, OnDestroy {
  categoryId!: any;
  categoryList: any[] = [];
  currentLanguage!: string;
  langChangeSubscription: Subscription | null = null;

  private subscriptions: Subscription = new Subscription();

  constructor(
    private _apiService: DjangoApiService,
    private _snackbarService: SnackbarService,
    private _languageService: LanguageService,
    private _translate: TranslateService,
    public _authService: AuthService,
    public _route: ActivatedRoute,
    private _dialog: MatDialog) {
  }

  ngOnInit() {
    this.setupLanguageSubscription();
    this.getRouteParams();
  }

  private setupLanguageSubscription(): void {
    this.currentLanguage = this._languageService.getLanguage();
    this.subscriptions.add(
      this.langChangeSubscription = this._translate.onLangChange.subscribe((event: LangChangeEvent) => {
        this.currentLanguage = event.lang;
      })
    );
  }

  private getRouteParams(): void {
    this._route.params.subscribe(params => {
      this.categoryId = this._route.snapshot.parent?.params['categoryId'];
      this.loadCategoryList();
    });
  }


  private loadCategoryList(): void {
    this.subscriptions.add(
      this._apiService.fetchCategoryList().subscribe({
        next: (response: any) => {
          this.categoryList = response;
        },
        error: (error: any) => {
          console.error('There was an error fetching the user information', error);
        }
      })
    );
  }


  confirmDelete(categoryId: number, event: Event) {
    event.stopPropagation();
    event.preventDefault();

    DialogConfirmComponent.openDeleteDialog(this._dialog, this._translate).subscribe(result => {
      if (result) {
        this.deleteCategory(categoryId);
      }
    });
  }

  private deleteCategory(categoryId: number): void {
    this.subscriptions.add(
      this._apiService.deleteCategory(categoryId).subscribe({
        next: (response: any) => {
          this.loadCategoryList();
          this._snackbarService.show(response.message);
        },
        error: (error: any) => {
          console.error('There was an error fetching the user information', error);
        }
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
